import { React } from 'react';
import { Typography } from '@material-ui/core';
import { Chip } from '@mui/material';
import useStyles from './styles';

export default function SubUsage(props) {
    const classes = useStyles();

    return (
        <>
            <div className={classes.boxContainer}>
                <Chip
                    style={{
                        color: '#4E4E4E',
                        fontWeight: 'bold'
                    }}
                    className={classes.boxHead}
                    label={props.label}
                />
                <div className={classes.boxFlex}>
                    <div className={classes.formTextFirst}>Minute</div>
                    <div className={classes.firstDaily} title={props.value.minute}>
                        {' '}
                        <Typography
                            variant="subtitle1"
                            style={{ textOverflow: 'ellipsis', overflow: 'hidden' }}
                            className={classes.innerSection}
                        >
                            {props.value.minute}
                        </Typography>
                    </div>
                </div>
                <div className={classes.boxFlex}>
                    <div className={classes.formTextFirst}>Hourly</div>
                    <div className={classes.firstDaily} title={props.value.hourly}>
                        {' '}
                        <Typography
                            variant="subtitle1"
                            style={{ textOverflow: 'ellipsis', overflow: 'hidden' }}
                            className={classes.innerSection}
                        >
                            {props.value.hourly}
                        </Typography>
                    </div>
                </div>
                <div className={classes.boxFlex}>
                    <div className={classes.formTextFirst}>Monthly</div>
                    <div className={classes.firstDaily} title={props.value.monthly}>
                        {' '}
                        <Typography
                            variant="subtitle1"
                            style={{ textOverflow: 'ellipsis', overflow: 'hidden' }}
                            className={classes.innerSection}
                        >
                            {props.value.monthly}
                        </Typography>
                    </div>
                </div>
            </div>
        </>
    );
}
